<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <SportipsButton backButton chevronLeft>Retour</SportipsButton>
            <div class="text-h5 font-weight-bold my-2">Les participants</div>
            <InscriptionsList mode="admin"></InscriptionsList>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import InscriptionsList from "@/components/ListInscriptions/InscriptionsList.vue";

export default {
  components: { InscriptionsList },
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
  },
  created() {

  },
};
</script>

<style lang="scss" scoped></style>